exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirmation[data-v-53821196],.confirmation-trigger[data-v-53821196]{display:contents}", ""]);

// exports
